export const toggleFund = (currentFund, selectedFunds, setSelectedFunds) => {
  const { agreementID, trpCode, ticker } = currentFund;
  const currentSelectedFund = { agreementID, trpCode, ticker };
  // filter saved selected funds based off current selected fund
  const filteredSelectedFunds = selectedFunds.filter(
    f => f.trpCode !== currentSelectedFund?.trpCode
  );
  // if lengths differ, then we're removing the current fund
  // when removing we want to only return funds already selected
  // otherwise we're adding the fund to the array of already selected funds
  return setSelectedFunds(
    filteredSelectedFunds.length === selectedFunds.length
      ? [...selectedFunds, currentFund]
      : filteredSelectedFunds
  );
};
